export class Settings{
    SMTPPort:string
    SMTPHost:string
    EnableEmailNotification: string
    EmailNotificationFrom: string
    EmailDeliveryAttempts:string
    DefaultEmailSubjectforTSS:string
    DefaultEmailSubjectforSummary:string
      }
      export interface CommonData {
        configurationName : string;
        configurationValue : string;
      }
      export class Post {
          Setting : CommonData[];
          ModifiedBy:string;
          constructor(obj) {
              this.Setting = obj.Setting as CommonData[];
      this.ModifiedBy=obj.ModifiedBy;
          }
      } 
      export class settingPayLoad {
        configurationName : string;
        configurationValue : string;
       // EnableEmailNotification: boolean;
      }

       
  